import React from 'react';
import ReactDOM from 'react-dom';
import './ParkingPageCSS.css';
import PrePaidCompoent from './discount/PrePaidDiscountParkingComponent';
import GeneralParkingComponent from './general/GeneralParkingInfoComponent';
import RatesDirectionsComponent from './ratesdirections/RatesDirectionsComponent';


class ParkingPageComponent extends React.Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';
        let sp = new URLSearchParams(window.location.search);
        this.state = {
            isSpanish,
            activeC: sp.has("node") ? sp.get("node") : '1'
        }
    }

    getComp = () => {
        switch (this.state.activeC) {
            case '0':
                return <GeneralParkingComponent />;
            case '1':
                return <PrePaidCompoent />;
            case '2':
                return <RatesDirectionsComponent />;
            default:
                return <GeneralParkingComponent />;
        }

    };

    handleHeaderClick = (n, e) => {
        e.preventDefault();
        this.setState(Object.assign(this.state, { activeC: n }))
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 p-0">
                        <img alt="Parking Header" className="img-fluid w-100 heading-image" src="/images/default-source/siteimages/page-headers/parkingheaderimage.jpg" />
                        <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,.4)', fontSize: 'calc(1.5em + 2.5vw)', fontWeight: 'bold', color: 'white', fontFamily: 'Calibri, sans-serif' }}>
                            <div style={{ position: 'relative', left: '2%', width: '98%' }}>{this.state.isSpanish ? "ESTACIONAMIENTO" : "PARKING"}</div>
                        </div>
                    </div>
                </div>
                <div className="row text-center mt-2 h-100">
                    <div className="col-4 col-md-4 mt-0 py-0 pl-0 pr-1">
                        <div className="row no-gutters pp-light-blue-background h-100">
                            <div className="col-12 py-2 lh-adjust pp-font-blue font-16 font-bold align-self-center" onClick={(e) => this.handleHeaderClick('0', e)}
                                style={this.state.activeC === '0' ? { color: 'white', textDecoration: 'none' } : {}}>
                                {this.state.isSpanish ? <div>Información General de<br />Estacionamiento</div> : <div>General Parking<br />Information</div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-4 col-md-4 mt-0 py-0 pl-0 pr-1">
                        <div className="row no-gutters pp-light-blue-background h-100">
                            <div className="col-12 py-2 lh-adjust pp-font-blue font-16 font-bold align-self-center" onClick={(e) => this.handleHeaderClick('1', e)}
                                style={this.state.activeC === '1' ? { color: 'white', textDecoration: 'none' } : {}}>

                                {this.state.isSpanish ? <div>PHX Estacionamiento<br />de Descuento</div> : <div>Sky Harbor<br />Discount Parking</div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-4 col-md-4 mt-0 py-0 pl-0 pr-0">
                        <div className="row no-gutters pp-light-blue-background h-100">
                            <div className="col-12 py-2 lh-adjust pp-font-blue font-16 font-bold align-self-center" onClick={(e) => this.handleHeaderClick('2', e)}
                                style={this.state.activeC === '2' ? { color: 'white', textDecoration: 'none' } : {}}>
                                {this.state.isSpanish ? <div>Tarifas de Estacionamiento y<br />Direcciones</div> : <div>Parking Rates and<br />Directions</div>}
                            </div>
                        </div>
                    </div>
                </div>

                {this.getComp()}
            </div>)
    }
}

let domContainer = document.querySelector('#parking-page-comp');

if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(
    <ParkingPageComponent />, domContainer);
